import BaseParser from './BaseParser';
import _get from 'lodash/get';
import { dateToString } from './util';
import { FhirDateTimeOptions, BaseParserOptions } from './SharedTypes';

class FhirDateTime extends BaseParser {
  private options: BaseParserOptions;

  /**
   * @param {String} options.fhirDateTime.monthFormat - Moment format string for dates with month specificity
   * @param {String} options.fhirDateTime.dayFormat - Moment format string for dates with day specificity
   * @param {String} options.fhirDateTime.minuteFormat - Moment format string for dates with minute specificity
   */
  constructor(options = {}) {
    super();

    this.options = options;
  }

  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getDisplayValue(fhirProperty: fhir.dateTime, isUtc: boolean = false) {
    if (!fhirProperty) return null;

    const dateTimeOptions = _get<
      BaseParserOptions,
      'fhirDateTime',
      FhirDateTimeOptions
    >(this.options, 'fhirDateTime', {});

    const formatOverride = {
      monthFormat: dateTimeOptions.monthFormat,
      dayFormat: dateTimeOptions.dayFormat,
      minuteFormat: dateTimeOptions.minuteFormat,
    };

    return dateToString(fhirProperty, formatOverride, isUtc);
  }

  /**
   * Returns the tick value of the FhirDateTime
   */
  // @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
  getSortValue(fhirProperty: fhir.dateTime) {
    const parsedTicks = Date.parse(fhirProperty);
    if (isNaN(parsedTicks)) return null;

    return parsedTicks;
  }
}

export default FhirDateTime;
